module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/CrateandBarrel-e1df445bc686950db54382d51118c931.png";